import { render } from "./AirtelNgTerms.vue?vue&type=template&id=6cd7eaa9&scoped=true"
import script from "./AirtelNgTerms.vue?vue&type=script&lang=js"
export * from "./AirtelNgTerms.vue?vue&type=script&lang=js"

import "./AirtelNgTerms.vue?vue&type=style&index=0&id=6cd7eaa9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd7eaa9"]])

export default __exports__